<div class="side-navigation-base-menu" [ngClass]="{ 'side-navigation-base-menu--hidden': hidden }">
  <div
    class="side-navigation-base-menu__hider"
    *ngIf="config.canHidden"
    (click)="toggleHidden()"
    [ngClass]="{ 'side-navigation-base-menu__hider--hidden': hidden }"
  >
    <svg-icon [src]="'/assets/img/arrow-down.svg'" [svgStyle]="{ width: '10px' }" />
  </div>

  <ng-container *ngIf="config.templateRef" [ngTemplateOutlet]="config.templateRef"></ng-container>

  <div class="side-navigation-base-menu__wrapper" *ngIf="!config.templateRef">
    <div
      class="side-navigation-base-menu__title"
      (click)="config.backAvailable ? onBackClick.emit(true) : null"
      [ngClass]="{
        'side-navigation-base-menu__title--with-back': config.backAvailable,
        'side-navigation-base-menu__title--hidden': hidden,
        'side-navigation-base-menu__title--no-padding': !!config?.headerTemplate
      }"
    >
      <ng-container
        *ngIf="config?.headerTemplate && !hidden"
        [ngTemplateOutlet]="config?.headerTemplate"
      ></ng-container>

      <svg-icon
        *ngIf="config.backAvailable"
        [src]="'/assets/img/ic-arrow-left.svg'"
        [svgStyle]="{ width: '20px', height: '20px' }"
      />
    </div>

    <div class="side-navigation-base-menu__content">
      <div
        class="side-navigation-base-menu__content__tab"
        [ngClass]="{ 'side-navigation-base-menu__content__tab--hidden': hidden }"
        [matTooltip]="tab.name"
        [matTooltipClass]="'side-navigation-tooltip'"
        matTooltipPosition="right"
        [matTooltipDisabled]="!hidden || tab.type === SideNavigationTabType.SECTION"
        *ngFor="let tab of config.tabs; trackBy: identify"
        matRipple
      >
        <a
          draggable="false"
          *ngIf="tab.type === SideNavigationTabType.TAB && tab.link"
          [routerLinkActive]="['side-navigation-base-menu__content__tab--active']"
          [routerLink]="[tab.link]"
          class="no-draggable"
        >
          <svg-icon *ngIf="tab.icon" [src]="tab.icon" [svgStyle]="{ width: '20px', height: '20px' }" />
          <span>{{ !hidden ? tab.name : '' }}</span>
          <span *ngIf="tab?.count > 0 && !hidden" class="ml-1">({{ tab.count }})</span>
        </a>

        <a
          draggable="false"
          *ngIf="tab.type === SideNavigationTabType.TAB && !tab.link"
          (click)="activateTab(tab)"
          [ngClass]="{ 'side-navigation-base-menu__content__tab--active': tab.active }"
          class="no-draggable"
        >
          <svg-icon *ngIf="tab.icon" [src]="tab.icon" [svgStyle]="{ width: '20px', height: '20px' }" />
          <span>{{ !hidden ? tab.name : '' }}</span>
          <span *ngIf="tab?.count > 0 && !hidden" class="ml-1">({{ tab.count }})</span>
        </a>

        <span *ngIf="tab.type === SideNavigationTabType.SECTION" [innerHTML]="!hidden ? tab.name : ''"></span>
      </div>
    </div>
  </div>
</div>
